import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = m[1];
    const role = sessionStorage.getItem("login_role") || "atleta";

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id, role });
        const user = res.data.user;
        setUser(user);
        sessionStorage.removeItem("login_role");
        // clear hash
        window.history.replaceState(null, "", window.location.pathname);
        if (user.role === "tecnico") navigate("/dashboard", { state: { user } });
        else navigate("/passaporte", { state: { user } });
      } catch (e) {
        console.error(e);
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-zinc-800 border-t-[#FF3B30] rounded-full animate-spin mx-auto" />
        <p className="mt-4 text-zinc-400 uppercase text-sm tracking-[0.3em] font-bold">Autenticando...</p>
      </div>
    </div>
  );
}
